import alert from 'redux/ducks/common/alertDucks';
import confirm from 'redux/ducks/common/confirmDucks';
import anniversary from 'redux/ducks/Anniversary/AnniversaryDucks';
import wizard from 'redux/ducks/common/wizardDuck';
import popup from 'redux/ducks/common/popupDucks';
import jobTitle from 'redux/ducks/JobTitle/JobTitleDucks';
import department from 'redux/ducks/Department/DepartmentDucks';
import adminInfo from 'redux/ducks/adminInfo/adminInfoDucks';
import menu from 'redux/ducks/GnbMenu/GnbMenuDucks';
import board from 'redux/ducks/Board/BoardDucks';
import home from 'redux/ducks/Home/HomeDucks';
import employee from 'redux/ducks/Employee/EmployeeDucks';
import invitation from 'redux/ducks/Employee/InvitationDucks';
import instant from 'redux/ducks/Employee/InstantDucks';
import account from 'redux/ducks/Employee/AccountDucks';
import terms from 'redux/ducks/Terms/TermsDucks';

export default {
  alert,
  confirm,
  anniversary,
  board,
  wizard,
  popup,
  adminInfo,
  jobTitle,
  menu,
  department,
  home,
  employee,
  terms,
  invitation,
  instant,
  account,
};
